export default "__VITE_ASSET__DzN3JTov__"